export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 12;
export const FIRST_PAGE = 1;
export const KEY = 'b190aa1d-f11d-4171-951d-31f45f070065';
export const MODAL_CLOSE_SEC = 2.5;
